import React, {Component} from 'react'
import * as firebase from 'firebase'
import * as firebaseui from 'firebaseui'

import UserCard from './react/UserCard'
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'
import Dialog from 'material-ui/Dialog'
import FlatButton from 'material-ui/FlatButton'


export default class Rewards extends Component {
  constructor(props) {
    super(props)
    this.state = {
      refereeKey: decodeURIComponent(window.location.pathname.split("/")[1]),
      block: false,
      uid: '',
      displayName: '',
      userEmail: '',
      photoURL: '',
      message: '',
      open: false
    }
  }

  handleClose = () => {
    this.setState({open: false});
  }

  render() {
    var self = this

    /**
     * Firebase & Firebase UI initialization variables
     */
    var config = {
      apiKey: "AIzaSyBaCFb5yACF2XePJVfnBGYDAYxncdXCiyM",
      authDomain: "awesome-petals.firebaseapp.com",
      databaseURL: "https://awesome-petals.firebaseio.com",
      projectId: "awesome-petals",
      storageBucket: "awesome-petals.appspot.com",
      messagingSenderId: "701784428235"
    }
    var uiConfig = {
      signInSuccessUrl: './',
      signInOptions: [
        // Leave the lines as is for the providers you want to offer your users.
        firebase.auth.GoogleAuthProvider.PROVIDER_ID,
        firebase.auth.FacebookAuthProvider.PROVIDER_ID,
      ],
      signInFlow: 'popup',
      // Terms of service url.
      tosUrl: '<your-tos-url>',
      callbacks: {
        signInSuccessWithAuthResult: function(authResult, redirectUrl) {
          var user = authResult.user;
          var credential = authResult.credential;
          var isNewUser = authResult.additionalUserInfo.isNewUser;
          var providerId = authResult.additionalUserInfo.providerId;
          var operationType = authResult.operationType;

          var displayName = user.displayName
          var email = user.email
          var photoURL = user.photoURL
          var phoneNumber = user.phoneNumber
          var providerData = user.providerData

          self.setState({
            block: true,
            uid: user.uid,
            displayName: displayName,
            userEmail: email,
            photoURL: photoURL,
            open: true
          })
          return false
        }
      }
    }
    if(!this.state.block) {
      firebase.initializeApp(config)
    }

    /**
     * Retrieve Referee's name and photo; render into fields on index.html
     */
    var database = firebase.database()
    database.ref('users/' + this.state.refereeKey +  "/profile/").on("value", function(snap) {
      console.log(snap.ref)
      if(snap.val()) {
        document.getElementById("refereePhoto").src = snap.val().photoUrl
        document.getElementById("bigtext").innerHTML=snap.val().name.split(" ")[0] + " wants to give you 20% off your first treatment!"
      }
    })

    /** Firebase UI Authentication flow & initialization logic
     * User's information is rendered only after loggin in
     */
    let ui = firebaseui.auth.AuthUI.getInstance();
    if (!ui) {
      ui = new firebaseui.auth.AuthUI(firebase.auth());
    }
    if(this.state.block & this.state.message == "") {
      ui.reset()
      console.log(this.state.message)
      const actions = [
        <FlatButton
          label="Cancel"
          primary={true}
          onClick={this.handleClose} />,
          <FlatButton
          label="Sign Out"
          primary={true}
          onClick={this.handleClose} />
    ];
      return (
        <div>
          <MuiThemeProvider>
            <Dialog
              modal={true}
              open={this.state.open}
              actions={actions}
              autoScrollBodyContent={true}>
              <UserCard
                refereeKey={this.state.refereeKey}
                uid={firebase.auth().currentUser.uid}
                userName={this.state.displayName}
                userEmail={this.state.userEmail}
                photoUrl={this.state.photoURL}/>
            </Dialog>
          </MuiThemeProvider>
          <br/>
        </div>
      )
    } else {
      ui.start('#firebaseui-auth-container', uiConfig)
      return (
        <div className="center">
      </div>
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/Rewards.js